import { render, staticRenderFns } from "./VehicleSelectSettings.vue?vue&type=template&id=13c9145c&"
import script from "./VehicleSelectSettings.vue?vue&type=script&lang=js&"
export * from "./VehicleSelectSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports